var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"lazyload",attrs:{"data-src":_vm.src,"alt":_vm.alt,"src":"https://static.ctwant.com/images/dist/imageholder.jpg","onerror":"this.src='https://static.ctwant.com/images/dist/default_cover_md.png'"}})}
var staticRenderFns = []

export { render, staticRenderFns }